function prod() {
  return window.location.hostname.indexOf('.com') > 0;
}
export const SERVER_URL = (prod() ? '' : 'https://bscqr.qtdatas.com'); // https://bscqr.qtdatas.com
// export const SERVER_URL = (prod() ? '' : ' http://192.168.1.42:58080')
// export const SERVER_URL = (prod() ? '' : 'http://bscqrdev.kurite.cn')




// WEBPACK FOOTER //
// ./config/host.js